import { gdOssUrl } from "@/utils/imageUrl";
import { FC } from "react";
import Image from "../Image";
import { TrackerDiv } from "../Tracker";
import styles from "./cardA.module.less";

interface IProps {
  columnSize: number;
  moduleLocation: number;
  record?: {
    recommendSearchWords?: RecommendSearchWordItem[];
    currentTabType?: string;
  };
}

interface RecommendSearchWordItem {
  word: string;
  ugc_url: string;
  pgc_url: string;
}

interface SingleSearchWordCardProps {
  searchWord: string;
  imageUrl?: string;
  style?: React.CSSProperties;
}

const RecommendSearchWordsCard: FC<IProps> = (props) => {
  const { columnSize, moduleLocation, record } = props;

  // 根据当前tab类型选择对应的图片URL并进行OSS裁剪压缩
  const getImageUrl = (item: RecommendSearchWordItem): string => {
    const originalUrl =
      record?.currentTabType === "material"
        ? item.pgc_url // 素材tab使用pgc_url
        : item.ugc_url; // 采集tab使用ugc_url

    if (!originalUrl) return "";

    // 对符合条件的域名进行OSS裁剪压缩处理
    if (/dancf\.com|grocery-cdn/.test(originalUrl)) {
      return gdOssUrl(originalUrl, {
        width: 160,
        height: 120,
        scaleType: "mfit", // 等比缩放并自动裁剪
        type: "webp", // 使用webp格式减少文件大小
        sharpen: 80, // 适当锐化
      });
    } else if (
      originalUrl?.includes("gd-hbimg.huaban.com") ||
      originalUrl?.includes("gd-hbimg-edge.huaban.com")
    ) {
      // 花瓣域名的图片使用imageUrl裁剪
      // 如果URL包含查询参数（auth_key），需要在文件名后插入尺寸后缀
      if (originalUrl.includes("?")) {
        const [base, query] = originalUrl.split("?");
        return `${base}_fw240?${query}`;
      }
      return originalUrl + "_fw240";
    }

    return originalUrl;
  };

  // 处理卡片点击事件
  const handleCardClick = (searchWord: string) => {
    // 构建搜索 URL
    const queryParams = new URLSearchParams({
      q: searchWord,
      original: searchWord,
      search_word_type: "瀑布流搜索推荐",
    });
    const searchUrl = `/search?${queryParams.toString()}`;

    // 新标签页打开
    window.open(searchUrl, "_blank");
  };

  // 使用真实数据，如果没有数据则使用空数组
  const dataSource: SingleSearchWordCardProps[] =
    record?.recommendSearchWords?.map((item) => ({
      searchWord: item.word,
      imageUrl: getImageUrl(item),
    })) || [];

  return (
    <div className={styles.container} style={{ width: columnSize }}>
      <div className={styles.header}>
        <div className={styles.title}>你可能感兴趣的灵感</div>
      </div>
      <div className={styles.content}>
        {dataSource.map((item, index) => (
          <TrackerDiv
            key={item.searchWord}
            className={styles.singleSearchWordCard}
            onClick={() => handleCardClick(item.searchWord)}
            data-gd-expose="resource_loc_expose"
            data-gd-click="resource_loc_click"
            data-module-name="详情瀑布流搜索推荐"
            data-subject-name="搜索词资源位"
            data-resource-title={item.searchWord}
            data-resource-location={index + 1}
            data-module-location={moduleLocation}
            data-search-word={item.searchWord}
          >
            {item.imageUrl && (
              <Image
                src={item.imageUrl}
                alt={item.searchWord}
                className={styles.searchWordImage}
              />
            )}
            <div className={styles.searchWord}>{item.searchWord}</div>
          </TrackerDiv>
        ))}
      </div>
    </div>
  );
};

export default RecommendSearchWordsCard;
